import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";

function Tooltip({ children, content }) {
  const [visible, setVisible] = useState(false);
  const containerRef = useRef(null);
  const [tooltipStyle, setTooltipStyle] = useState(null);
  const animationFrameRef = useRef(null);

  const updatePosition = () => {
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    let left = 0;
    let transform = "none";

    if (viewportWidth < 768) {
      if (rect.left < viewportWidth / 3) {
        left = 0;
      } else if (rect.left >= viewportWidth / 3 && rect.left < (2 * viewportWidth) / 3) {
        left = "50%";
        transform = "translateX(-50%)";
      } else {
        left = viewportWidth;
        transform = "translateX(-100%)";
      }
    } else {
      if (rect.left <= viewportWidth / 2) {
        left = `${rect.left}px`;
        transform = "none";
      } else {
        left = `${rect.right}px`;
        transform = "translateX(-100%)";
      }
    }

    setTooltipStyle({
      position: "fixed",
      top: rect.top + rect.height,
      left: left,
      transform: transform,
      zIndex: 9999,
    });

    animationFrameRef.current = requestAnimationFrame(updatePosition);
  };

  useEffect(() => {
    if (visible) {
      updatePosition();
    }

    return () => {
      cancelAnimationFrame(animationFrameRef.current);
    };
  }, [visible]);

  const renderTooltip = () => {
    if (!visible || !tooltipStyle) return null;

    const appRoot = document.querySelector(".App") || document.body;

    return ReactDOM.createPortal(
      <div className="tooltip-2-text" style={tooltipStyle}>
        {React.cloneElement(content, { onClose: () => setVisible(false) })}
      </div>,
      appRoot
    );
  };


  return (
    <div
      ref={containerRef}
      className="tooltip-2-container"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      style={{
        position: "relative",
        display: "inline-block",
      }}
    >
      {children}
      {renderTooltip()}
    </div>
  );
}

export default Tooltip;
